/** No-op ERPPort adapter. */
export function createNoneERP() {
  return {
    async status() { return { status: "not_connected", vendor: "none" }; },
    async listInvoicesForActor() { return []; },
    async listCatalog() { return []; },
    async createQuote() { throw new Error("ERP_NOT_CONFIGURED"); },
    async createOrder() { throw new Error("ERP_NOT_CONFIGURED"); },
  };
}
